export default __webpack_public_path__ + "static/jingle-d7baf03ab877e89dd3b319a47c91514e.mp3";